import { useEffect, useState } from "react";
import { Dropdown, DropdownMenu, DropdownItem, FormField, FormGroup, Checkbox, Form } from "semantic-ui-react";
import { getAllOperationStatus, IOperationStatus, updateOperationStatus } from "services/remoteControl";


export default function RemoteControl(props: any) {
  const { hotel } = props;
  const isDmel = hotel?.id === "6449e7e5abd582feb900edbd";
  const [allOperationStatus, setAllOperationStatus] =
    useState<IOperationStatus[]>();
    const [selectedOperationStatus, setSelectedOperationStatus] =
      useState<IOperationStatus>();
      const [selectedOperationStatusId, setSelectedOperationStatusId] =
        useState<string>();

  useEffect(()=>{
    getAllOperationStatus().then(response=>setAllOperationStatus(response))
  },[])

  const selectOperationStatus =(e:any,value:any)=>{
    setSelectedOperationStatus(allOperationStatus?.find(x=>x.id === value.value))
  }

  const checkboxChangeHandler = async(
    event: React.FormEvent<HTMLInputElement>,
    data:any
  ) => {
   if(selectedOperationStatus){ const value = data.checked;
    const updatedOperationStatus = {
      ...selectedOperationStatus,
      [data.name]: data.checked,
    };
    await updateOperationStatus(updatedOperationStatus);
    setSelectedOperationStatus(updatedOperationStatus);
  };
  }

  return allOperationStatus ? (
    <>
      <Dropdown
        placeholder="GSR"
        search
        selection
        options={allOperationStatus
          .sort((a, b) =>
            a.alias > b.alias ? 1 : b.alias > a.alias ? -1 : 0
          )
          .map((x) => {
            return { key: x.id, text: x.alias, value: x.id };
          })}
        onChange={selectOperationStatus}
        value={selectedOperationStatusId}
        style={{ margin: 5 }}
      />
      <Form>
        <Checkbox
          label="Check In"
          name="checkIn"
          checked={selectedOperationStatus?.checkIn ?? false}
          onChange={checkboxChangeHandler}
          style={{ margin: 5 }}
        />
        <Checkbox
          label="Check Out"
          checked={selectedOperationStatus?.checkOut ?? false}
          name="checkOut"
          onChange={checkboxChangeHandler}
          style={{ margin: 5 }}
        />
        <Checkbox
          label="Key Pick Up"
          checked={selectedOperationStatus?.keyPickUp ?? false}
          name="keyPickUp"
          onChange={checkboxChangeHandler}
          style={{ margin: 5 }}
        />
      </Form>
    </>
  ) : (
    <></>
  );
}
